import { categories, hotTags } from "@/mocks/discussion";

const FOOT_NAV = [
  { label: "热议广场", href: "#feed" },
  { label: "围观分类", href: "#category" },
  { label: "今日话题", href: "#today" },
  { label: "群众热议", href: "#chatter" },
  { label: "热议FAQ", href: "#faq" },
  { label: "我要爆料", href: "#submit" },
];

export default function Footer() {
  return (
    <footer className="bg-background-200/80">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          {/* 品牌 */}
          <div className="lg:col-span-2">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-white">
                <i className="ri-fire-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl text-foreground-950">
                爆料<span className="text-primary-500">网</span>
              </span>
            </a>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              爆料网是一个中文在线热议讨论社区，汇集明星八卦、影视娱乐、社会热点与科技趣闻。
              吃瓜群众已就位，欢迎实时开麦，参与最热话题的围观与讨论。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href="#top"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600 ring-1 ring-background-300 transition-colors hover:text-primary-500"
                aria-label="微博"
              >
                <i className="ri-weibo-line" aria-hidden="true"></i>
              </a>
              <a
                href="#top"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600 ring-1 ring-background-300 transition-colors hover:text-primary-500"
                aria-label="微信"
              >
                <i className="ri-wechat-line" aria-hidden="true"></i>
              </a>
              <a
                href="mailto:hello@baoliaowang.cn"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600 ring-1 ring-background-300 transition-colors hover:text-primary-500"
                aria-label="邮箱"
              >
                <i className="ri-mail-line" aria-hidden="true"></i>
              </a>
            </div>
          </div>

          {/* 快速导航 */}
          <div>
            <h3 className="text-sm font-bold text-foreground-950">快速围观</h3>
            <ul className="mt-4 space-y-2.5">
              {FOOT_NAV.map((n) => (
                <li key={n.label}>
                  <a href={n.href} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 专区 + 联系 */}
          <div>
            <h3 className="text-sm font-bold text-foreground-950">围观专区</h3>
            <ul className="mt-4 grid grid-cols-2 gap-x-3 gap-y-2.5">
              {categories.map((c) => (
                <li key={c.id}>
                  <a href="#category" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {c.name}
                  </a>
                </li>
              ))}
            </ul>
            <h3 className="mt-6 text-sm font-bold text-foreground-950">联系我们</h3>
            <p className="mt-2 flex items-center gap-2 text-sm text-foreground-600">
              <i className="ri-mail-line text-primary-500" aria-hidden="true"></i>
              <a href="mailto:hello@baoliaowang.cn" className="hover:text-primary-600">hello@baoliaowang.cn</a>
            </p>
          </div>
        </div>

        {/* 热词 */}
        <div className="mt-10 border-t border-background-300/70 pt-6">
          <div className="flex flex-wrap items-center gap-2">
            <span className="flex items-center gap-1 text-xs font-semibold text-foreground-700">
              <i className="ri-hashtag text-primary-500" aria-hidden="true"></i>
              热门围观词
            </span>
            {hotTags.map((t) => (
              <a key={t} href="#top" className="rounded-full bg-background-50 px-3 py-1 text-xs text-foreground-500 transition-colors hover:text-primary-600">
                {t}
              </a>
            ))}
          </div>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-background-300/70 pt-6 text-xs text-foreground-500 sm:flex-row">
          <p>© {new Date().getFullYear()} 爆料网 Baoliao Wang · 在线热议讨论社区</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-heart-line text-primary-500" aria-hidden="true"></i>
            理性吃瓜 · 友善发言
          </p>
        </div>
      </div>
    </footer>
  );
}